import { milliseconds } from "./key-milliseconds";
export function date(key) {
    return new Date(milliseconds(key));
}
